import React from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { isEmpty } from "ramda";
import { constants, Stack, Title } from "@thecb/components";
import DisplayCard from "/components/display-card";
import AlertBar from "/components/alert-bar";
import { configureEndpoint } from "/util/router-utils";

const ProfileSettings = ({
  actions,
  resources,
  alertBars,
  customerManagement,
  themeValues
}) => {
  const linkColor = themeValues.activeTabAccent;
  const { profileSettingsAlertBar: alertBar } = alertBars;
  const {
    alertBars: { profileSettingsAlertBar: alertBarActions }
  } = actions;

  return (
    <Stack childGap="24px" role="main">
      {!isEmpty(alertBar.alerts) && (
        <AlertBar {...alertBar} {...alertBarActions} />
      )}
      <Stack childGap="16px">
        <Title
          weight={constants.fontWeights.FONT_WEIGHT_SEMIBOLD}
          as="h1"
          variant="small"
        >
          Login & Security
        </Title>
        <DisplayCard
          title="Name"
          titleAs="h2"
          item={`${resources.firstName} ${resources.lastName}`}
          linkText="Edit Name"
          linkDisabled={!!customerManagement}
          linkURL={configureEndpoint(
            customerManagement,
            "/profile/settings/edit-name"
          )}
          themeValues={themeValues}
        />
        <DisplayCard
          title="Username"
          titleAs="h2"
          item={resources.email}
          helpText="Not Editable"
          hasTooltip
          themeValues={themeValues}
          tooltipID="username-tooltip"
          linkDisabled={!!customerManagement}
          tooltipTriggerColor={linkColor}
          tooltipTriggerText="What's this?"
          tooltipContent="This email address was used to register. It cannot be changed."
          contentPosition={{
            top: "auto",
            bottom: "calc(100% + 1rem)",
            left: "auto",
            right: "1rem"
          }}
        />
        <DisplayCard
          title="Password"
          titleAs="h2"
          item="•••••••••••••"
          linkDisabled={!!customerManagement}
          linkText="Change Password"
          linkURL={configureEndpoint(
            customerManagement,
            "/profile/settings/change-password"
          )}
          themeValues={themeValues}
        />
      </Stack>
    </Stack>
  );
};

export default connect(null, { push })(React.memo(ProfileSettings));
